export const onClickOverlay = (event: any) => {
  if (event.target.classList.contains('visible-responsive')) {
    event.target.classList.remove('visible-responsive');
  }
};

export const onClickClose = () => {
  const element = document.querySelector('.visible-responsive') as HTMLElement;
  element.classList.remove('visible-responsive');
};
